// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"contactBlockStyles_cardWrapper__IRq18"};